// extracted by mini-css-extract-plugin
export default {"photos-grid":"PhotosGrid_photos-grid__MyblH","photo-frame":"PhotosGrid_photo-frame__gATIY"};